/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Compare_Macros_GcInputs */

const en_gc_resources_compare_macros_gc = /** @type {(inputs: Gc_Resources_Compare_Macros_GcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not supported`)
};

const zh_gc_resources_compare_macros_gc = /** @type {(inputs: Gc_Resources_Compare_Macros_GcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不支持`)
};

/**
* | output |
* | --- |
* | "Not supported" |
*
* @param {Gc_Resources_Compare_Macros_GcInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_compare_macros_gc = /** @type {((inputs?: Gc_Resources_Compare_Macros_GcInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Compare_Macros_GcInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_compare_macros_gc(inputs)
	return zh_gc_resources_compare_macros_gc(inputs)
});
export { gc_resources_compare_macros_gc as "gc.resources.compare.macros.gc" }